export const SEND_SURVEY = 'SURVEY_SEND_SURVEY'
export const ADD_OK_RESPONSE = 'SURVEY_ADD_OK_RESPONSE'
export const ADD_ERROR_RESPONSE = 'SURVEY_ADD_ERROR_RESPONSE'
export const CLEAR_RESPONSE = 'SURVEY_CLEAR_RESPONSE'
export const LOAD_SURVEY = 'SURVEY_LOAD_SURVEY'

export const sendSurvey = (survey) => {
  return { type: SEND_SURVEY, data: survey }
}

export const clearResponse = () => {
  return { type: CLEAR_RESPONSE }
}
export const addErrorResponse = (message) => {
  return { type: ADD_ERROR_RESPONSE, data: message }
}

export const addOkResponse = (message) => {
  return { type: ADD_OK_RESPONSE, data: message }
}

export const loadSurvey = () => {
  return { type: LOAD_SURVEY }
}
